import { Color, DoubleSide, ShaderMaterial, Vector3, Vector4 } from "three";
import electronShader_frag from "./electrons_frag.glsl";
import electronShader_vert from "./electrons_vert.glsl";

export const PulsingMaterial = ({
  colorA = new Vector4(1, 0, 0, 1),
  colorB = new Vector4(0, 0, 1, 1),
  width = 1,
  spacing = 0.1,
  sharpness = 1,
  speed = 0.3,
  blend = 1,
  uEmissiveA = new Vector3(1, 1, 1),
  uEmissiveIntensityA = 0,
  uEmissiveB = new Vector3(1, 1, 1),
  uEmissiveIntensityB = 0,
}) =>
  new ShaderMaterial({
    fragmentShader: electronShader_frag,
    vertexShader: electronShader_vert,
    transparent: true,
    depthWrite: false,
    depthTest: true,
    side: DoubleSide,
    uniforms: {
      uColorA: {
        value: colorA,
      },
      uColorB: {
        value: colorB,
      },
      uWidth: {
        value: width,
      },
      uSpacing: {
        value: spacing,
      },
      uTime: {
        value: 0,
      },
      uSharpness: {
        value: sharpness,
      },
      uSpeed: {
        value: speed,
      },
      uBlend: {
        value: blend,
      },
      uEmissiveA: { value: uEmissiveA },
      uEmissiveIntensityA: { value: uEmissiveIntensityA },
      uEmissiveB: { value: uEmissiveB },
      uEmissiveIntensityB: { value: uEmissiveIntensityB },
    },
  });
